module.exports = __webpack_public_path__ + "img/coloredDiamonds.95f8f80.jpg";